'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  height: ', ';\n  width: ', ';\n  background-color: ', ';\n  border-radius: 50%;\n  border: ', ';\n  margin: 0;\n  justify-content: center;\n  align-items: center;\n'], ['\n  display: flex;\n  height: ', ';\n  width: ', ';\n  background-color: ', ';\n  border-radius: 50%;\n  border: ', ';\n  margin: 0;\n  justify-content: center;\n  align-items: center;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']);

// hixme-ui


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icon = require('@hixme-ui/icon');

var _icon2 = _interopRequireDefault(_icon);

var _title = require('@hixme-ui/title');

var _title2 = _interopRequireDefault(_title);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Circle = _styledComponents2.default.div(_templateObject, function (_ref) {
  var size = _ref.size;
  return size + 'px' || '48px';
}, function (_ref2) {
  var size = _ref2.size;
  return size + 'px' || '48px';
}, function (_ref3) {
  var color = _ref3.color,
      openCircle = _ref3.openCircle;
  return !openCircle && color;
}, function (_ref4) {
  var openCircle = _ref4.openCircle,
      color = _ref4.color,
      width = _ref4.width;
  return openCircle && width + ' solid ' + color;
});

var IconContainer = _styledComponents2.default.div(_templateObject2);

var Step = function Step(_ref5) {
  var borderWidth = _ref5.borderWidth,
      children = _ref5.children,
      completed = _ref5.completed,
      openCircle = _ref5.openCircle,
      size = _ref5.size,
      uncompletedColor = _ref5.uncompletedColor;
  return _react2.default.createElement(
    IconContainer,
    null,
    completed ? _react2.default.createElement(_icon2.default, { primary: true, checkMarkCircle: true, fontSize: size }) : _react2.default.createElement(
      Circle,
      {
        color: uncompletedColor,
        size: size,
        openCircle: openCircle,
        width: borderWidth
      },
      children && _react2.default.createElement(
        _title2.default,
        { thin: true, white: true, small: true },
        children
      )
    )
  );
};

Step.displayName = 'Step';
Step.propTypes = {
  borderWidth: _propTypes2.default.string,
  children: _propTypes2.default.node,
  completed: _propTypes2.default.bool,
  openCircle: _propTypes2.default.bool,
  size: _propTypes2.default.number,
  uncompletedColor: _propTypes2.default.string
};

Step.defaultProps = {
  borderWidth: '3px',
  children: null,
  completed: false,
  openCircle: false,
  size: 48,
  uncompletedColor: '#677786'
};

exports.default = Step;
//# sourceMappingURL=Step.js.map


//////////////////
// WEBPACK FOOTER
// ../step/lib/Step.js
// module id = 758
// module chunks = 0